import NotificationDetail from './NotificationDetail';

export default NotificationDetail;
